/// <reference path="../typings/index.d.ts" />

import * as _ from "underscore";
//import {Center} from './Center';

declare var EventBus: any;

window["Registre"] = (name: string): void => {
    $.get('/Data/Prosess', (prosess) => {
        var navn = "reg_" + name;
        var options: DevExpress.ui.dxDataGridOptions = {
            dataSource: [],
            filterRow: {
                visible: true,
                applyFilter: "auto"
            },
            headerFilter: {
                visible: false
            },
            selection: {
                mode: "single"
            },
            "export": {
                enabled: true,
                fileName: name,
                allowExportSelectedData: true
            },
            summary: {
                totalItems: [{
                    column: "id",
                    summaryType: "count"
                }]
            },
            loadPanel: true,
            noDataText: "Henter...",
            rowAlternationEnabled: true,
            allowColumnResizing: true,
            columnAutoWidth: true,
            editing: {
                mode: 'row',
                allowAdding: true,
                allowUpdating: true,
                allowDeleting: true
            },
            onRowUpdated: (e) => {
                var updatedItem = e.key;
                //debugger;
                if (updatedItem.kjoretid) {
                    //var datestr = (new Date()).toISOString().substring(0, 11) + updatedItem.kjoretid + "Z";
                    //var dato = new Date(datestr);                  
                    //var ticks = ((dato  .getTime() * 10000) + 621355968000000000);
                    //updatedItem.kjoretid = ticks;
                    //updatedItem.kjoretid = null;
                }
                    
                $.post("/Data/" + name, updatedItem)
                    .done(() => {
                        DevExpress.ui.notify("Update successful!", "success", 2000);
                        //EventBus.dispatch("refresh_grid");
                    })
                    .fail(() => {
                        DevExpress.ui.notify("Update failed!", "error", 2000);
                    });
            },
            onRowInserted: (e) => {
                var insertedItem = _.assign(e.data, { id: 0 });
                $.post("/Data/" + name, insertedItem)
                    .done((data) => {
                        DevExpress.ui.notify("Insert successful!", "success", 2000);
                    })
                    .fail(() => {
                        DevExpress.ui.notify("Insert failed!", "error", 2000);
                    });
            },
            onRowRemoved: (e) => {
                $.post("/Data/" + name + "?doDelete=true", e.data)
                    .done((data) => {
                        DevExpress.ui.notify("Insert successful!", "success", 2000);
                    })
                    .fail(() => {
                        DevExpress.ui.notify("Insert failed!", "error", 2000);
                    });
            }
        } as DevExpress.ui.dxDataGridOptions;

        if (name === "Bruker") {
            name = "BrukerNew";
        } else if (name === "Aktivitetsitem") {
            options.columns = <any>["id", "navn", "beskrivelse", "rapportvisning", "starttidspunkt",
                {
                    visible: true,
                    dataField: "prosessId",
                    lookup: {
                        dataSource: prosess,
                        valueExpr: 'id',
                        displayExpr: 'navn'
                    }
                }
            ];
            options.onEditingStart = (e) => {
            };
            options.editing = {
                mode: "row",
                allowAdding: true,
                allowUpdating: true,
                allowDeleting: true
            };
        } else if (name === "Produksjonstype") {
            options.columns = <any>["id", "navn", "beskrivelse", "rapportvisning",
                {
                    visible: true,
                    dataField: "prosessId",
                    lookup: {
                        dataSource: prosess,
                        valueExpr: 'id',
                        displayExpr: 'navn'
                    }
                }
            ];
            options.editing = {
                mode: "row",
                allowAdding: true,
                allowUpdating: true,
                allowDeleting: true
            };
        } else if (name === "Selskap") {
            options.columns = <any>["id", "navn", "beskrivelse", "forfallDager", "historisk", 
                {
                    visible: true,
                    dataField: "land",
                    lookup: {
                        dataSource: [{ id: 1, navn: 'Sverige' }, { id: 2, navn: 'Norge' }, { id: 3, navn: 'Finland' }],
                        valueExpr: 'id',
                        displayExpr: 'navn'
                    }
                }
            ];
            options.editing = {
                mode: "row",
                allowAdding: true,
                allowUpdating: true,
                allowDeleting: true
            };
        }
        $.get("/Data/" + name)
            .done((data) => {
                options.dataSource = data;
                $("#" + navn).dxDataGrid(options).dxDataGrid("instance");
            })
            .fail(() => {
                //grid.option("noDataText", "Registre kan ikke finnes");
                DevExpress.ui.notify("Registre kan ikke finnes!", "error", 2000);
            })
            .always(() => {
            });
    });
};

function bruker() {
    alert('asdf');
}

function gridForAspNetUsers(grid: DevExpress.ui.dxDataGrid, registreToChange: string) {
    $.get("/Data/AspNetRoles", (aspnetroles) => {
        grid.option({
            editing: false,
            columns:[
                {
                    dataField: "id"
                }, {
                    dataField: "userName"
                }, {
                    dataField: "email"
                }, {
                    dataField: "phoneNumber"
                }, {
                    dataField: "roles",
                    calculateCellValue: (usr) => {
                        // Turns array of objects containing roleIds into "Admin, Bruker, Control"
                        var roles = usr.roles;
                        return roles.reduce((previousValue, currentElem, currentIndex) => {
                            var roleName = _.find(aspnetroles, (rol:any) => rol.id === currentElem.roleId).name;
                            if (currentIndex === 0) {
                                return previousValue.concat(roleName);
                            } else {
                                return previousValue.concat(", " + roleName);
                            }
                        }, "");
                    }
                }
            ]
        });
        grid.option("masterDetail", {
            enabled: true,
            template: (container, options) => {
                container.addClass("internal-grid-container p10");
                var userId = options.data.id
                $.get("/Data/Countries", (countries) => {
                    var formId = "form-" + userId;
                    var regionlistId = "regionlist-" + userId;
                    var rolelistId = "rolelist-" + userId;
                    var formOptions: DevExpress.ui.dxFormGroupItem[] = [{
                            itemType: "group",
                            caption: "Roles",
                            template: $("<div>").attr("id", rolelistId)
                        }
                    ];
                    container.append($("<div>").attr("id", formId));
                    $("#" + formId).dxForm({
                        colCount: 2,
                        items: formOptions,
                        width: 400
                    });
                    // Lists inside form
                    var roleList = $("#" + rolelistId).dxList({
                        dataSource: aspnetroles,
                        itemTemplate: (item) => item.name,
                        allowItemDeleting: false,
                        showSelectionControls: true,
                        selectionMode: "multiple",
                        onSelectionChanged: function(data) {
                            console.log(data.component.option("selectedItems"));
                        },
                        selectedItems: aspnetroles
                                        .filter(r => options.data.roles.find(it => it.roleId === r.id)) 
                    }).dxList("instance");
                    // Lagre bruker button
                    var saveButtonId = "save-" + userId;
                    container.append($("<div>").attr("id", saveButtonId));
                    $("#" + saveButtonId).dxButton({
                        text: "Lagre bruker",
                        type: "success",
                        onClick: () => {
                            var selectedRoles = roleList.option("selectedItems");
                            var roleParameters = {
                                user: options.data,
                                rolesToAdd: selectedRoles.map(r => r.name),
                                rolesToRemove: aspnetroles.filter(r => !selectedRoles.find(f => r.id === f.id)).map(r => r.name)
                            };
                            $.post("/Account/SetRoles", roleParameters)
                            .done(() => {
                                DevExpress.ui.notify("Bruker lagret!", "success", 2000);
                                // Update users in grid
                                $.get("/Data/" + registreToChange)
                                .done((data) => {
                                    grid.option("dataSource", data);
                                })
                                .fail(() => {
                                    grid.option("noDataText", "Registre kan ikke finnes");
                                    DevExpress.ui.notify("Registre kan ikke finnes!", "error", 2000);
                                });
                            })
                            .fail(() => {
                                DevExpress.ui.notify("Bruker ikke lagret!", "error", 2000);
                            });
                        }
                    });
                });
            }
        });
    });
}


// WEBPACK FOOTER //
// ./TS/registre.ts